//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import M_TBG_BASIC_03 from './M_TBG_BASIC_03';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

function M_TBG_BASIC_03F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const activeStep = useSelector((state) => state.common.activeStep);

  // onBack 클로저가 activeStep 최신값을 참조하도록 ref 사용
  const activeStepRef = useRef(activeStep);
  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const [inputs, setInputs] = useState({
    video: '',
    isNext: false,
  });
  const [fullUrl, setFullUrl] = useState();
  const [renderPreview, setRenderPreview] = useState([]);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfFile, setPdfFile] = useState();
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1);
  const [pageViewHeight, setPageViewHeight] = useState(0);
  //#endregion

  // 뒤로가기: 미리보기 단계 이탈 시 저장/step 롤백
  // 언마운트 시 자동으로 스택에서 제거됨
  useBackStack({
    type: 'custom',
    onBack: () => {
      SaveLogic1(1, 0);
      props.ActiveButton({
        type: 'prev',
        content: true,
        step: 1,
      });
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1));
    },
  });

  //#region 이벤트
  useEffect(() => {
    Init();
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [pageNumber]);

  const Init = async () => {
    setLoading(true);
    try {
      await SearchLogic1();
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 조회
  const SearchLogic1 = async () => {
    setLoading(true);
    setInputs({
      ...inputs,
      isNext: true,
    });

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R2',
            _userid: userInfo.userid,
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          if (!data[0].EDU_LOCATION) {
            setInputs({ ...inputs, isNext: true });
          } else {
            setInputs({ ...inputs });
            const path = data[0].EDU_LOCATION.replace(/\.[^/.]+$/, '.pdf');
            const full = Global.file.useUrl + 'files/' + path;

            setPdfFile(path);
            setFullUrl(full);

            if (getExtensionFromUrl(path) === 'pdf') {
              generatePdfPreview(full);
            }
          }
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 저장
  const SaveLogic1 = async (_eStep, _mStep) => {
    setLoading(true);
    let saveData = [];

    try {
      saveData.push({
        procedureName: 'SP_TBM_STATUS_U1',
        _TBM_CD: Commons.EncryptAES(props.tbmCdRef.current) || '',
        _E_STEP: Commons.EncryptAES(_eStep.toString()) || '',
        _M_STEP: Commons.EncryptAES(_mStep.toString()) || '',
        _USER_ID: userInfo.userid,
      });

      if (saveData.length > 0) {
        await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        ).then(async (result) => {
          let data = result?.data[0];
          if (data.type === 'Error') {
            throw new Error(data.message);
          }
        });
      }
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    }
  };
  //#endregion

  //#region 나머지 함수
  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };

  const generatePdfPreview = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const base64 = await BlobToBase64(blob);
    setRenderPreview(base64);
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    } else {
      dispatch(CommonActions.setActiveStep(activeStep - 1));
    }
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };

  const BlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  //#endregion

  return (
    <M_TBG_BASIC_03
      userInfo={userInfo}
      pdfFile={pdfFile}
      loading={loading}
      setLoading={setLoading}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      pageNumber={pageNumber}
      pageWidth={pageWidth}
      numPages={numPages}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      pageViewHeight={pageViewHeight}
      setPageViewHeight={setPageViewHeight}
      SaveLogic1={SaveLogic1}
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
      ActiveButton={props.ActiveButton}
      renderPreview={renderPreview}
      fullUrl={fullUrl}
      getExtensionFromUrl={getExtensionFromUrl}
    />
  );
}

export default M_TBG_BASIC_03F;
